module.exports = __webpack_public_path__ + "img/null.5707106f.png";